module.exports = __webpack_public_path__ + "img/27.9b776db2.jpg";